export enum HttpError {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
}
